@if (isDisabled()) {
  <button type="button" (click)="open()" class="mt-1 mt-sm-0 btn btn-outline-primary pr-3 pl-3">
    {{ 'actionBar.label.quickEntry' | cxTranslate }}
  </button>
}
